import { DialogProps } from '@mui/material';

export const EVENT_DIALOG_MAX_WIDTH: DialogProps['maxWidth'] = 'xl';

export const EVENT_DIALOG_PAPER_SX: DialogProps['PaperProps'] = {
    sx: {
        borderRadius: { xs: 0, sm: 3 },
        boxShadow: '0px 20px 45px rgba(15, 23, 42, 0.16)',
        width: { xs: '100%', sm: 'min(96vw, 980px)', lg: 'min(92vw, 1120px)' },
        maxWidth: { xs: '100%', sm: '980px', lg: '1120px' },
    },
};
